export class FilterConsts {
    static readonly All = 'all';
    static readonly Pending = 'pending';
    static readonly Approved = 'approved';
    static readonly Delivered = 'delivered';
    static readonly Received = 'received';
    static readonly Rejected = 'rejected';
}